import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Email } from '@mui/icons-material';

const ContactSection = () => {
  return (
    <Box
      id="contact"
      sx={{
        py: 8,
        bgcolor: 'rgba(255, 255, 255, 0.5)',
        borderTop: '1px solid rgba(102, 126, 234, 0.1)',
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              mb: 2,
              color: '#1f2937',
            }}
          >
            Get in Touch
          </Typography>
          
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              mt: 3,
            }}
          >
            <Email sx={{ fontSize: '2rem', color: '#6366f1' }} />
            <Typography
              component="a"
              href="mailto:admin@stratovai.ai"
              sx={{
                fontSize: '1.5rem',
                color: '#6366f1',
                textDecoration: 'none',
                fontWeight: 600,
                '&:hover': {
                  textDecoration: 'underline',
                  color: '#6366f1',
                }
              }}
            >
              admin@stratovai.ai
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ContactSection;

